export default "__VITE_ASSET__$hWdAeSG__"